import api from './api';

// ============================================================================
// CATÁLOGO (grupos y operaciones)
// ============================================================================

export const getOperationGroups = async () => {
  const response = await api.get('/superadmin/groups');
  return response.data;
};

export const getOperationTypes = async (groupId = null) => {
  const params = groupId ? { group_id: groupId } : {};
  const response = await api.get('/superadmin/operations', { params });
  return response.data;
};

export const getOperationParams = async (operationKey) => {
  const response = await api.get(`/superadmin/operations/${operationKey}/params`);
  return response.data;
};

export const getSearchableParams = async () => {
  const response = await api.get('/superadmin/params/searchable');
  return response.data;
};

// Legacy: actualizar prompt de grupo
export const updateGroupPrompt = async (groupId, prompt) => {
  const response = await api.put(`/superadmin/groups/${groupId}/prompt`, { prompt });
  return response.data;
};

// Nuevo: actualizar prompt de operación individual
export const updateOperationPrompt = async (operationId, prompt) => {
  const response = await api.put(`/superadmin/operations/${operationId}/prompt`, { prompt });
  return response.data;
};

// ============================================================================
// CONFIGURACIÓN DE CUENTA (operaciones individuales)
// ============================================================================

export const getAccountConfig = async (accountId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/config`);
  return response.data;
};

export const getAccountOperations = async (accountId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/operations`);
  return response.data;
};

export const setAccountOperations = async (accountId, operationTypeIds, enabled = true) => {
  const response = await api.post(`/superadmin/accounts/${accountId}/operations`, {
    operation_type_ids: operationTypeIds,
    enabled,
  });
  return response.data;
};

export const toggleAccountOperation = async (accountId, operationId, enabled) => {
  const response = await api.put(`/superadmin/accounts/${accountId}/operations/${operationId}`, {
    enabled,
  });
  return response.data;
};

// Legacy aliases
export const getAccountGroups = getAccountOperations;
export const setAccountGroups = setAccountOperations;
export const toggleAccountGroup = toggleAccountOperation;

// ============================================================================
// ACCOUNT CUSTOM PROMPTS
// ============================================================================

/**
 * Get all operations for an account with their prompt status
 * @param {number} accountId - Account ID
 * @returns {Promise<Array>} List of operations with prompt info
 */
export const getAccountPrompts = async (accountId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/prompts`);
  return response.data;
};

/**
 * Get prompt details for a specific operation and account
 * @param {number} accountId - Account ID
 * @param {number} operationId - Operation type ID
 * @returns {Promise<Object>} Operation prompt details
 */
export const getAccountOperationPrompt = async (accountId, operationId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/prompts/${operationId}`);
  return response.data;
};

/**
 * Update custom prompt for a specific operation and account
 * @param {number} accountId - Account ID
 * @param {number} operationId - Operation type ID
 * @param {string} prompt - Custom prompt text
 * @returns {Promise<Object>} Response message
 */
export const updateAccountPrompt = async (accountId, operationId, prompt) => {
  const response = await api.put(`/superadmin/accounts/${accountId}/prompts/${operationId}`, {
    prompt,
  });
  return response.data;
};

/**
 * Reset custom prompt to use global default
 * @param {number} accountId - Account ID
 * @param {number} operationId - Operation type ID
 * @returns {Promise<Object>} Response message
 */
export const resetAccountPrompt = async (accountId, operationId) => {
  const response = await api.post(`/superadmin/accounts/${accountId}/prompts/${operationId}/reset`);
  return response.data;
};

// ============================================================================
// CONFIGURACIÓN DE SIMILITUD
// ============================================================================

export const getAccountSimilarity = async (accountId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/similarity`);
  return response.data;
};

export const setAccountSimilarityParam = async (accountId, paramConfig) => {
  const response = await api.post(`/superadmin/accounts/${accountId}/similarity`, paramConfig);
  return response.data;
};

export const deleteAccountSimilarityParam = async (accountId, paramDefinitionId) => {
  const response = await api.delete(`/superadmin/accounts/${accountId}/similarity/${paramDefinitionId}`);
  return response.data;
};

// ============================================================================
// MODELOS LLM
// ============================================================================

export const getLLMModels = async (enabledOnly = true) => {
  const response = await api.get('/superadmin/llm-models', {
    params: { enabled_only: enabledOnly }
  });
  return response.data;
};

export const getAccountLLMConfig = async (accountId) => {
  const response = await api.get(`/superadmin/accounts/${accountId}/llm-config`);
  return response.data;
};

export const updateAccountLLMConfig = async (accountId, config) => {
  const response = await api.put(`/superadmin/accounts/${accountId}/llm-config`, config);
  return response.data;
};
